/* tslint:disable */
/* eslint-disable */
export enum PrebidResult {
  Pending = 'pending',
  Outbid = 'outbid',
  Won = 'won',
  CreditExhausted = 'credit_exhausted',
  PrebidGroupFulfilled = 'prebid_group_fulfilled'
}
